var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1678_1560",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05571 2.33822C8.35858 1.03534 10.471 1.03534 11.7738 2.33822C13.0767 3.64109 13.0767 5.75347 11.7738 7.05634L7.99933 10.8308C7.21761 11.6126 5.95018 11.6126 5.16845 10.8308C4.38673 10.0491 4.38673 8.78169 5.16845 7.99997L8.94296 4.22547C9.20353 3.96489 9.62601 3.96489 9.88658 4.22547C10.1472 4.48604 10.1472 4.90852 9.88658 5.16909L6.11208 8.94359L6.06023 9.00179C5.85283 9.2637 5.87012 9.64526 6.11208 9.88722C6.35404 10.1292 6.7356 10.1465 6.99751 9.93907L7.05571 9.88722L10.8302 6.11272C11.6119 5.33099 11.6119 4.06357 10.8302 3.28184C10.0485 2.50012 8.78106 2.50012 7.99933 3.28184L4.22483 7.05634C2.92195 8.35922 2.92195 10.4716 4.22483 11.7745C5.49342 13.0431 7.52946 13.0764 8.83844 11.8746L8.94296 11.7745L12.7175 7.99997C12.978 7.73939 13.4005 7.73939 13.6611 7.99997C13.9217 8.26054 13.9217 8.68302 13.6611 8.94359L9.88658 12.7181C8.06256 14.5421 5.10523 14.5421 3.2812 12.7181C1.45718 10.8941 1.45718 7.93674 3.2812 6.11272L7.05571 2.33822Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1678_1560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#374151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.f1e386f0.svg";
export { ForwardRef as ReactComponent };